<script>
import Privacy from './privacy.svelte';

let ta_input='{\n "some_array": [1, 2, { "key": "value" } ]\n}', ta_output, output;
window.ta_output = ta_output;
let wait_response;

async function convert() {
  try {
    var test_parse = JSON.parse(ta_input);
  } catch (ex) {
    ta_output = 'Unable to parse json: ' + ex.message;
    output.classList.add('btn-danger');
    return;
  }

  try {
    ta_output = '';
    wait_response = true;
    const rawResponse = await fetch(window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/convert', {
      method: 'POST',
      headers: {
        'Accept': 'text/html',
        'Content-Type': 'application/json'
      },
      body: ta_input
    });
    const content = await rawResponse.text(); //.json();
    console.log(rawResponse);
    if (false === rawResponse.ok ) { //.status >= 400) {
      ta_output = 'Network error';
      output.classList.add('btn-danger');
    } else {
      ta_output = (content);
      output.classList.remove('btn-danger');
    }
  } catch (ex) {
    output.classList.add('btn-danger');
    console.log(typeof ex);
    if ('Failed to fetch' === ex.message) {
      ta_output = 'Network error, try again in a minute';
    } else {
      ta_output = 'Failed to process. Validate JSON';
    }
  }
  setTimeout( () => wait_response = false, 400);
}

function copy() {
  /* output.focus() */
  output.select();
  document.execCommand('copy');
  output.setSelectionRange(0,0);
  window.output = output;
  output.classList.add('btn-success')
  setTimeout(() => output.classList.remove('btn-success'), 150);
}

</script>

<main>
  <div class="parent">
    <div class="header">
      <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
        <a class="navbar-brand" href="https://jestify.me">
          Jestify.me - help writing jest test code
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor01" aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarColor01">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <a class="nav-link" href="#privacy" data-toggle="modal" data-target="#privacy">Privacy policy</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://iconix.dev/">Visit iconix.dev</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div class="info">
      {#if wait_response}
        <span class="text-warning">Please wait</span>
      {:else}
        Paste JSON and click <button on:click={convert} class="btn btn-primary">Convert</button>
        Then you can <button on:click={copy} class="btn btn-primary">Copy results</button>
      {/if}
    </div>
    <textarea bind:value={ta_input} class="form-control" rows="3" />
    <textarea bind:this={output} bind:value={ta_output} class="form-control" rows="3" readonly/>
    <div class="footer">
      Jestify.me - Generate Jest test code from JSON data
    </div>
  </div>

  <div class="modal" id='privacy'>
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Jestify.me - Our Privacy policy</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Privacy/>
        </div>
        <div class="modal-footer">
          <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!--
  <div class="modal" id='contact'>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Modal title</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Contact details here. Coming soon</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  -->
</main>

<style type="text/scss">
  main {
    width: 100%;
    height: 100%;
  }

  .parent {
    display: grid;
    width: 100%;
    height: 100%;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 2fr 1fr 8fr 2fr;
    grid-column-gap: 5px;
    grid-row-gap: 2px;
  }

  .header { grid-area: 1 / 1 / 2 / 3; }
  .info { grid-area: 2 / 1 / 3 / 3; }
  .input { grid-area: 3 / 1 / 4 / 2; }
  .output { grid-area: 3 / 2 / 4 / 3; }
  .footer { 
    grid-area: 4 / 1 / 5 / 3; 
  }

  textarea {
    width: 100%;
    height: 100%;
    resize: none;
  }


  @import "cerulean.min.css";
</style>
